import React, { useState } from "react";
import {
  Button,
  Card,
  CardBody,
  Col,
  FormFeedback,
  FormGroup,
  Input,
  Label,
  Row,
} from "reactstrap";
import Styles from "../../homework/assets/Form.module.css";
import { toast } from "react-toastify";
import { Link, useLocation, useNavigate } from "react-router-dom";
import axiosInstance from "../../../axiosInterceptor";
import CommonEditor from ".././CommonEditor";

const AddBlogsCategory = () => {
  const location = useLocation();
  const blogsCategoryData = location.state;
  const [formSubmitted, setFormSubmitted] = useState(false);
  const navigator = useNavigate();
  const [data, setData] = useState({
    title: blogsCategoryData?.title || "",
    description: blogsCategoryData?.description || "",
    isActive: blogsCategoryData?.isActive ?? true,
    url: blogsCategoryData?.url || "",
    metaTitle: blogsCategoryData?.metaTitle || "",
    metaKeywords: blogsCategoryData?.metaKeywords || "",
    metaDescription: blogsCategoryData?.metaDescription || "",
  });
  const handleChange = (e) => {
    const { name, files, type, checked, value } = e.target;

    if (type === "file") {
      setData({ ...data, [name]: files?.[0] || null });
    } else if (type === "checkbox" || type === "switch") {
      setData({ ...data, [name]: checked });
    } else {
      setData({ ...data, [name]: value });
    }
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setFormSubmitted(true);
    if (!data.title) {
      return;
    }
    try {
      const response = await axiosInstance.post(
        `admin/blogsCategory/createBlogCategory`,
        data,
        {
          headers: { "Content-Type": "application/json" },
        },
      );
      if (response.status === 200) {
        toast.success(response.data.message);
        navigator("/blogs-category");
      } else {
        toast.error(response.data.message);
      }
    } catch (error) {
      toast.error(error.response.data.message || "Something went wrong");
    }
  };

  const handleUpdate = async (e) => {
    e.preventDefault();
    setFormSubmitted(true);
    if (!data.title) {
      return;
    }
    try {
      const response = await axiosInstance.put(
        `admin/blogsCategory/updateBlogCategory/${blogsCategoryData?._id}`,
        data,
        {
          headers: { "Content-Type": "application/json" },
        },
      );
      if (response.status === 200) {
        toast.success(response.data.message);
        navigator("/blogs-category");
      } else {
        toast.error(response.data.message);
      }
    } catch (error) {
      toast.error(error.response.data.message || "Something went wrong");
    }
  };
  return (
    <div>
      <div className="mt-4 mb-4">
        <div className="row">
          <div className="col-sm-6">
            <h4 className="page-title">
              {blogsCategoryData?._id
                ? "Edit Blogs Category"
                : "Add Blogs Category"}
            </h4>
          </div>
        </div>
        <Card className="mt-4">
          <CardBody>
            <Row>
              <Col md="12">
                <form
                  className="ps-5 pe-5 pt-3"
                  onSubmit={
                    blogsCategoryData?._id ? handleUpdate : handleSubmit
                  }
                >
                  <div className="row form-group">
                    <div className="col-sm-6 mb-4">
                      <Label for="blogsTitle" className="col-form-label">
                        Title
                      </Label>
                      <Input
                        type="text"
                        className="form-control"
                        id="blogsTitle"
                        placeholder="Enter Title"
                        invalid={
                          !blogsCategoryData && !data.title && formSubmitted
                        }
                        name="title"
                        value={data.title}
                        onChange={(e) => handleChange(e)}
                      />
                      <FormFeedback>Title is required</FormFeedback>
                    </div>

                    <div className="col-sm-6 mb-4">
                      <Label for="blogsUrl" className="col-sm-4 col-form-label">
                        Url
                      </Label>
                      <Input
                        type="text"
                        className="form-control"
                        id="blogsUrl"
                        placeholder="Enter Url"
                        name="url"
                        value={data.url}
                        onChange={(e) => handleChange(e)}
                      />
                    </div>

                    <div className="col-sm-12 mb-4 mt-2">
                      <Label for="description" className="col-form-label">
                        Description
                      </Label>
                      <CommonEditor
                        value={data.description}
                        placeholder="Enter subject description..."
                        onChange={(value) =>
                          handleChange({
                            target: { name: "description", value },
                          })
                        }
                      />
                    </div>

                    <div className="col-sm-6 mb-4">
                      <Label for="metaTitle" className="col-form-label">
                        Meta Title
                      </Label>
                      <Input
                        type="text"
                        className="form-control"
                        id="metaTitle"
                        placeholder="Enter subject meta title"
                        name="metaTitle"
                        invalid={
                          !blogsCategoryData && !data.metaTitle && formSubmitted
                        }
                        value={data.metaTitle}
                        onChange={(e) => handleChange(e)}
                        rows={5}
                      />
                      <FormFeedback>Blogs meta title is required</FormFeedback>
                    </div>
                    <div className="col-sm-6 mb-4">
                      <Label for="metaKeywords" className="col-form-label">
                        Meta Keywords
                      </Label>
                      <Input
                        type="text"
                        className="form-control"
                        id="metaKeywords"
                        placeholder="Enter subject meta keywords"
                        name="metaKeywords"
                        invalid={
                          !blogsCategoryData &&
                          !data.metaKeywords &&
                          formSubmitted
                        }
                        value={data.metaKeywords}
                        onChange={(e) => handleChange(e)}
                        rows={5}
                      />
                      <FormFeedback>
                        Blogs meta keywords is required
                      </FormFeedback>
                    </div>
                    <div className="col-sm-12 mb-4">
                      <Label for="metaDescription" className="col-form-label">
                        Meta Description
                      </Label>
                      <Input
                        type="textarea"
                        className="form-control"
                        id="metaDescription"
                        placeholder="Enter subject meta description"
                        name="metaDescription"
                        invalid={
                          !blogsCategoryData &&
                          !data.metaDescription &&
                          formSubmitted
                        }
                        value={data.metaDescription}
                        onChange={(e) => handleChange(e)}
                        rows={5}
                      />
                      <FormFeedback>
                        Blogs meta description is required
                      </FormFeedback>
                    </div>

                    <br />
                    <div className="col-sm-4 mb-4">
                      <Label for="isActive" className="col-sm-4 col-form-label">
                        isActive
                      </Label>
                      <div className="col-sm-8">
                        <FormGroup switch>
                          <Input
                            type="switch"
                            id="isActive"
                            name="isActive"
                            checked={data.isActive}
                            onChange={handleChange}
                            className={`${Styles.form_check_input}`}
                          />
                          <Label check className="mx-1">
                            {data.isActive ? "Active" : "Deactive"}
                          </Label>
                        </FormGroup>
                      </div>
                    </div>
                  </div>
                  <div className="form-group row mb-4">
                    <Label
                      for="inputPassword"
                      className="col-sm-4 col-form-label"
                    >
                      <b className="ms-2"></b>
                    </Label>
                    <div className="col-sm-7 d-flex">
                      <div className={`${Styles.submit_button}`}>
                        <Button type="submit">
                          {blogsCategoryData?._id ? "Update" : "Save"}
                        </Button>
                      </div>
                      <div className={`${Styles.cancel_button} me-4 mx-2`}>
                        <Link to="/blogs-category">
                          {" "}
                          <Button className={`${Styles.cancel_button}`}>
                            Cancel
                          </Button>
                        </Link>
                      </div>
                    </div>
                  </div>
                </form>
              </Col>
            </Row>
          </CardBody>
        </Card>
      </div>
    </div>
  );
};

export default AddBlogsCategory;
